import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

const NoContent: React.FC = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate(-1);
  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '85vh',
      }}
    >
      NO CONTENT
      <Button onClick={handleBack}>Go Back</Button>
    </div>
  );
};

export default NoContent;
